import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {useState, useCallback} from 'react';
import {Tag} from 'bbcode-to-react';
import EventEmitter from '../../../utils/emmiter';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EnImage from '../image/image';
import VideoPlayer from '../video/video2';

import parser from 'bbcode-to-react';

import Button from 'react-bootstrap/Button';
import styled from 'styled-components';

import './bbcode.css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export class ColorTag extends Tag {
  toReact() {
    var color = this.params.color;
    if( this.params.color.match(/[A-F0-9]/i) != null && this.params.color.length === 6 ) {
      color = '#' + this.params.color;
    }
    const attributes = {
      color: color,
    };
    return (
      <span style={attributes} className={color}>
        {this.getComponents()}
      </span>
    );
  }
}

export class BGColorTag extends Tag {
  toReact() {
    var color = this.params.bgcolor;
    if( this.params.bgcolor.match(/[A-F0-9]/i) != null && this.params.bgcolor.length === 6 ) {
      color = '#' + this.params.bgcolor;
    }
    const attributes = {
      backgroundColor: color,
      padding: '0px 5px',
    };
    return (
      <span style={attributes}>
        {this.getComponents()}
      </span>
    );
  }
}

export class LeftTag extends Tag {
  toReact() {
    return (
      <span style={{textAlign:"left"}}>
        {this.getComponents()}
      </span>
    );
  }
}
export class CenterTag extends Tag {
  toReact() {
    return (
      <span style={{ display: "flex", justifyContent: "center" }}>
        {this.getComponents()}
      </span>
    );
  }
}
export class RightTag extends Tag {
  toReact() {
    return (
      <span style={{ display: "flex", justifyContent: "right" }}>
        {this.getComponents()}
      </span>
    );
  }
}
export class Image extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      largeImage: false,
      update: false,
    };
    this.showImage = this.showImage.bind(this);
  }
  showImage() {
    this.setState({largeImage: !this.state.largeImage, update: true},()=>{this.shouldComponentUpdate();});
  }
  shouldComponentUpdate(nextProps, nextState) {
    if( this.state.update ) this.setState({update: false});
    return this.state.update;
  }
  render() {
    return (
      <>
        {/*<img className={this.state.largeImage?'bbcode-image-large':'bbcode-image'} onClick={this.showImage} src={this.props.text} alt="Custom User Upload" />*/}
        <EnImage src={this.props.text} alt="Custom User Upload" className="bbcode-image" />
      </>
    );
  }
}
class ImageTag extends Tag {
  toReact() {
    return (
      <Image name={this.params.spoiler} text={this.getComponents()} />
    )
  }
}

export class InUrlTag extends Tag {
  toReact() {
    return (
      <Link to={this.params.inurl}>{this.getComponents()}</Link>
    );
  }
}

export class FontSizeTag extends Tag {
  toReact() {
    return(
      <font size={this.params.size}>{this.getComponents()}</font>
    )
  }
}

export class FontTag extends Tag {
  toReact() {
    return(
      <font style={{fontFamily: this.params.font}}>{this.getComponents()}</font>
    )
  }
}

export class AnchorTag extends Tag {
  toReact() {
    return(
      <div id={this.getComponents()}></div>
    )
  }
}

export class PaddingTag extends Tag {
  toReact() {
    return(
      <span style={{paddingLeft: `${this.params.padding}px`}}>{this.getComponents()}</span>
    )
  }
}

class Spoiler extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visable: false,
    }
    this.showHide = this.showHide.bind(this);
  }
  showHide() {
    this.setState({visable: !this.state.visable});
  }
  render() {
    return (
      <>
        {this.state.visable===true ?
          <>
            <div style={{paddingLeft: '60px'}}>
              <div className="float-right">
                <Button variant="outline-warning" size="sm" onClick={this.showHide} className="button-spoiler">X</Button>
              </div>
              {this.props.text}
            </div>
          </>
        :
          <Button variant="outline-warning" size="sm" onClick={this.showHide} className="button-spoiler">Show {this.props.name?this.props.name:'Spoiler'}</Button>
        }
      </>
    )
  }
}

class SpoilerTag extends Tag {
  toReact() {
    return (
      <Spoiler name={this.params.spoiler} text={this.getComponents()} />
    )
  }
}

export class RadioTag extends Tag {
  toReact() {
    const Play = () => {
      EventEmitter.emit('/radio/open', { id: this.params.radio } );
    }
    return (
      <Link to="#" onClick={Play}>{this.getComponents()}</Link>
    )
  }
}

export class BRTag extends Tag {
	toReact() {
		return(
			<><br />{this.getComponents()}</>
		)
	}
}

export class BRFile extends Tag {
  
	toReact() {
    let file = [];
    try{
      file = this.getComponents()[0].split('|');
    } catch(error) {}
		return(
      <>
        {file.length===4&&
          <Row className="gx-0">
            <div className="files-gallery-type">
              <a href={file[0]}><img src={`https://mix365.co.uk/images/filetypes/${file[2]}.png`} alt="File type" /></a>
            </div>
            <Col className="files-gallery-content">
              <a href={file[0]}>{file[1]}<br />
              Size: {file[3]}</a>
            </Col>
          </Row>
        }
      </>
		)
	}
}

class TimeTag extends Tag {
  toReact() {
    return (
      <>{moment(this.getComponents()*1000).format("HH:mm")} </>
    )
  }
}

class SocialTag extends Tag {
  toReact() {
    return (
      <>
        {this.params.facebook &&
          <a href={this.getComponents()[0]} title="Facebook" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={['fab', 'facebook-f']} className="header-socials" style={{padding: '0.25em'}} />
          </a>
        }
        {this.params.instagram &&
          <a href={this.getComponents()[0]} title="Instagram" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={['fab', 'instagram']} className="header-socials" style={{padding: '0.25em'}} />
          </a>
        }
        {this.params.social === 'mixcloud' &&
          <a href={this.getComponents()[0]} title="Mixcloud" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={['fab', 'mixcloud']} className="header-socials" style={{padding: '0.25em'}} />
          </a>
        }
        {this.params.soundcloud &&
          <a href={this.getComponents()[0]} title="Soundcloud" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={['fab', 'soundcloud']} className="header-socials" style={{padding: '0.25em'}} />
          </a>
        }
        {this.params.twitch &&
          <a href={this.getComponents()[0]} title="Twitch" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={['fab', 'twitch']} className="header-socials" style={{padding: '0.25em'}} />
          </a>
        }
        {this.params.youtube &&
          <a href={this.getComponents()[0]} title="Youtube" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={['fab', 'youtube']} className="header-socials" style={{padding: '0.25em'}} />
          </a>
        }
      </>
    )
  }
}

class VideoTag extends Tag {
  toReact() {
    return (
      <VideoPlayer
        id="random"
        customUrl={this.getComponents()}
        mute={true}
        onError={()=>{}}
      />
    )
  }
}

class T1Tag extends Tag {
  toReact() {
    return (
      <>
        <div className="bbcode-text1">
          {this.getComponents()}
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" style={{height: 0}}>
          <defs>
            <filter id="squiggly-0">
              <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="0"/>
              <feDisplacementMap id="displacement" in="SourceGraphic" in2="noise" scale="6" />
            </filter>
            <filter id="squiggly-1">
              <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="1"/>
              <feDisplacementMap in="SourceGraphic" in2="noise" scale="8" />
            </filter>
            <filter id="squiggly-2">
              <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="2"/>
              <feDisplacementMap in="SourceGraphic" in2="noise" scale="6" />
            </filter>
            <filter id="squiggly-3">
              <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="3"/>
              <feDisplacementMap in="SourceGraphic" in2="noise" scale="8" />
            </filter>
            <filter id="squiggly-4">
              <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="4"/>
              <feDisplacementMap in="SourceGraphic" in2="noise" scale="6" />
            </filter>
          </defs> 
        </svg>
      </>
    )
  }
}
class T2Tag extends Tag {
  toReact() {
    return (
      <div className="bbcode-text2"><h1>{this.getComponents()}</h1></div>
    )
  }
}

class T3 extends React.Component {
  constructor(props) {
    super(props);
    
    function getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    //---- first dived by 2
    let split0 = getRandomInt(Math.floor(this.props.text.length/2), Math.ceil(this.props.text.length/2));
    let first = this.props.text.substring(0,split0);
    let third = this.props.text.substring(split0);

    //---- split first section
    let split1 = getRandomInt(Math.floor(first.length/2), Math.ceil(first.length/2));
    let second = first.substring(split1);
    first = first.substring(0, split1);

    //---- split second section
    let split2 = getRandomInt(Math.floor(third.length/2), Math.ceil(third.length/2));
    let fourth = third.substring(split2);
    third = third.substring(0, split2);

    this.state = {
      string: [first, second, third, fourth],
    }
  }
  render() {
    return (
      <div className="bbcode-text3 text-vertical">
        <div className="sign">
          <span className="fast-flicker">{this.state.string[0]}</span>{this.state.string[1]}<span className="flicker">{this.state.string[2]}</span>{this.state.string[3]}
        </div>
      </div>
    )
  }
}

class T3Tag extends Tag {
  toReact() {
    return (
      <T3 text={this.getComponents().toString()} />
    )
  }
}
class T4Tag extends Tag {
  toReact() {
    return (
      <div className="bbcode-text4">
        <div className="stage">
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
          <div className="layer"></div>
        </div>
      </div>
    )
  }
}
const Layer = styled.div`
  & {
    
  }
  &:after {
    /*content: "${props => props.content}";*/
  }

`;
class T5Tag extends Tag {
  toReact() {
    return (
      <div className="bbcode-text5"><h1 className="Blazing" >{this.getComponents()}</h1></div>
    )
  }
}

class BBCode extends React.Component {
  linkify(text) {
    return (text || '').replace(/([^\S]|^)(((https?\:\/)|(www\.))(\S+))/gi, function (match, space, url) {
      var hyperlink = url;
      if (!hyperlink.match('^https?://')) {
        hyperlink = 'http://' + hyperlink;
      }
      return `${space}[url=${hyperlink}]${url}[/url]`;
    });
    
    //var Rexp = /(\b(https?|ftp|file):\/\/([-A-Z0-9+&@#%?=~_|!:,.;]*)([-A-Z0-9+&@#%?\/=~_|!:,.;]*)[-A-Z0-9+&@#\/%=~_|])/ig;
    //return string.replace(Rexp,"[url=$1]$1[/url]");
  }
	render() {
		parser.registerTag('color', ColorTag);
    parser.registerTag('bgcolor', BGColorTag);
    parser.registerTag('left', LeftTag);
    parser.registerTag('center', CenterTag);
    parser.registerTag('right', RightTag);
    parser.registerTag('img', ImageTag);
    parser.registerTag('inurl', InUrlTag);
    parser.registerTag('size', FontSizeTag);
    parser.registerTag('font', FontTag);
    parser.registerTag('anchor', AnchorTag);
    parser.registerTag('padding', PaddingTag);
    parser.registerTag('spoiler', SpoilerTag);
    parser.registerTag('radio', RadioTag);
		parser.registerTag('br', BRTag);
    parser.registerTag('file', BRFile);
    parser.registerTag('time', TimeTag);
    parser.registerTag('social', SocialTag);
    parser.registerTag('video', VideoTag);
    parser.registerTag('t1', T1Tag);
    parser.registerTag('t2', T2Tag);
    parser.registerTag('t3', T3Tag);
    parser.registerTag('t4', T4Tag);
    parser.registerTag('t5', T5Tag);
		return (
			<span style={{color: this.props.className?this.props.className:"var(--text)", fontSize: "var(--text-size)", inlineSize: 'min-content', overflowWrap: 'break-word', whiteSpace: 'normal', wordBreak: 'break-word'}}>
				{parser.toReact(this.linkify(this.props.text.toString()))}
      </span>
		);
	}
}

export default BBCode;